import { KeyValuePair } from './../../../documents/document-filter-item';
import { AdminSponsorsStorage } from './../../sponsor-storage/admin-sponsors-storage';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { MandatoryFilterItemsLoader } from '../../../documents/mandatory-filter-items-loader';
import { AdminProtocolsStorage } from '../../shared';

@Injectable()
export class AdminDocumentsMandatoryFilterItemsStorage implements MandatoryFilterItemsLoader {

    constructor(
        private readonly adminSponsorsStorage: AdminSponsorsStorage,
        private readonly adminProtocolsStorage: AdminProtocolsStorage,
    ) { }

    public getItemsFilter(): Observable<KeyValuePair[]> {
        return this.adminSponsorsStorage.getAll()
            .pipe(
                map(sponsors => sponsors.map(sp => {
                    const sponsorFilterItem = new KeyValuePair();
                    sponsorFilterItem.key = sp.sponsorId;
                    sponsorFilterItem.value =  sp.sponsorTitle;
                    return sponsorFilterItem;
                })));
    }
    public getProtocolFilter(): Observable<KeyValuePair[]> {
        return this.adminProtocolsStorage.all
            .pipe(
                map(protocols => protocols.map(pr => {
                    const protocolFilterItem = new KeyValuePair();
                    protocolFilterItem.key = pr.id.toString();
                    protocolFilterItem.value = pr.protocolName;
                    return protocolFilterItem;
                })));
    }
}